module.exports = __webpack_public_path__ + "assets/img/3_294_big.03bbeb36.jpg";